import { DemoIdSchema, DemoSourceSchema, parseContract } from "@rnavoyager/contracts";
import { Type } from "@sinclair/typebox";
import type { Static } from "@sinclair/typebox";
const pendingSchema = Type.Object(
  {
    caseId: DemoIdSchema,
    caseDigest: Type.String({ pattern: "^[a-f0-9]{64}$" }),
    question: Type.String({ minLength: 1, maxLength: 32_000 }),
    requestId: Type.String({ pattern: "^[A-Za-z0-9_-]{1,128}$" }),
    seriesId: Type.Optional(Type.String({ minLength: 1, maxLength: 64 })),
  },
  { additionalProperties: false },
);
export type PendingDemo = Static<typeof pendingSchema>;
const pendingKey = "rnavoyager.demo.pending";
export function readPendingDemo(): PendingDemo | null {
  try {
    const value = sessionStorage.getItem(pendingKey);
    return value ? parseContract(pendingSchema, JSON.parse(value)) : null;
  } catch {
    return null;
  }
}
export function savePendingDemo(pending: PendingDemo): void {
  sessionStorage.setItem(pendingKey, JSON.stringify(parseContract(pendingSchema, pending)));
}
export function clearPendingDemo(): void {
  sessionStorage.removeItem(pendingKey);
}
export type DemoHistorySource = Static<typeof DemoSourceSchema>;
const historyKey = (identityId: string, sessionId: string) =>
  `rnavoyager.demo.history.${identityId}.${sessionId}`;
/** 这里只保存界面恢复所需的公开案例标识，身份与会话分别绑定。 */
export function readDemoHistorySource(
  identityId: string,
  sessionId: string,
): DemoHistorySource | null {
  try {
    const value = sessionStorage.getItem(historyKey(identityId, sessionId));
    return value ? parseContract(DemoSourceSchema, JSON.parse(value)) : null;
  } catch {
    return null;
  }
}
export function saveDemoHistorySource(
  identityId: string,
  sessionId: string,
  source: DemoHistorySource,
): void {
  try {
    sessionStorage.setItem(
      historyKey(identityId, sessionId),
      JSON.stringify(parseContract(DemoSourceSchema, source)),
    );
  } catch {
    /* 隐私模式仍在当前工作区展示已导入的记录。 */
  }
}
export function readDemoProgress(caseDigest: string): number {
  try {
    const value = sessionStorage.getItem(`rnavoyager.demo.progress.${caseDigest}`);
    const phase = value === null ? -2 : Number(value);
    // -3 为规划等待；刷新仍先完成等待，再进入 -1 的方案确认阶段。
    return Number.isInteger(phase) && phase >= -3 && phase <= 4 ? phase : -2;
  } catch {
    return -2;
  }
}
export function saveDemoProgress(caseDigest: string, phase: number): void {
  try {
    sessionStorage.setItem(`rnavoyager.demo.progress.${caseDigest}`, String(phase));
  } catch {
    /* 隐私模式仍可在当前页面探索。 */
  }
}
